import React from 'react';

const ImportedTag = () => {
	return <span className="status red-3 import-status">Imported</span>;
};

export default ImportedTag;
